import { useTranslation } from 'react-i18next'

import {
    Button,
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    showDialog,
} from '@/components/new/ui'

export type WebPushDialogPermission = Exclude<NotificationPermission | 'unsupported', 'granted'>

type WebPushPermissionDialogProps = {
    permission: WebPushDialogPermission
    close: (confirmed?: boolean) => void
}

const WebPushPermissionDialog = ({ permission, close }: WebPushPermissionDialogProps) => {
    const { t } = useTranslation()
    const i18nKey = 'utils.webPush'
    const webPushDialogKey =
        permission === 'default'
            ? 'permissionPrompt'
            : permission === 'denied'
              ? 'permissionDenied'
              : 'permissionUnsupported'

    return (
        <Dialog open onOpenChange={(open) => !open && close(false)}>
            <DialogContent showCloseButton={false}>
                <DialogHeader>
                    <DialogTitle>{t(`${i18nKey}.${webPushDialogKey}.dialogTitle`)}</DialogTitle>
                    <DialogDescription>{t(`${i18nKey}.${webPushDialogKey}.dialogDescription`)}</DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    {permission === 'default' ? (
                        <>
                            <Button variant="outline" onClick={() => close(false)}>
                                {t(`${i18nKey}.permissionPrompt.cancel`)}
                            </Button>
                            <Button onClick={() => close(true)}>{t(`${i18nKey}.permissionPrompt.confirm`)}</Button>
                        </>
                    ) : (
                        <Button variant="outline" onClick={() => close(false)}>
                            {t('actions.close')}
                        </Button>
                    )}
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

export const showWebPushPermissionDialog = (permission: WebPushDialogPermission) => {
    return showDialog<boolean>(({ close }) => <WebPushPermissionDialog permission={permission} close={close} />)
}
